import {
    RESET_PLAYER_REPORT,
    GET_PLAYER_REPORT,
    GET_PLAYER_REPORT_SUCCESS,
    GET_PLAYER_REPORT_ERROR,
    GET_PLAYER_REPORT_BY_TIME,
    GET_PLAYER_REPORT_BY_TIME_SUCCESS,
    GET_PLAYER_REPORT_BY_TIME_ERROR,
} from '../constants/ActionTypes';

export const resetPlayerReport = () => {
    return {
        type: RESET_PLAYER_REPORT,
    };
};

export const getPlayerReport = (payload) => {
    return {
        type: GET_PLAYER_REPORT,
        payload: payload
    };
};

export const getPlayerReportSuccess = (getPlayerReportResponse) => {
    return {
        type: GET_PLAYER_REPORT_SUCCESS,
        payload: getPlayerReportResponse
    };
};

export const getPlayerReportError = (getPlayerReportResponse) => {
    return {
        type: GET_PLAYER_REPORT_ERROR,
        payload: getPlayerReportResponse
    };
};


export const getPlayerByTimeReport = (payload) => {
    return {
        type: GET_PLAYER_REPORT_BY_TIME,
        payload: payload
    };
};

export const getPlayerReportByTimeSuccess = (getPlayerReportByTimeResponse) => {
    return {
        type: GET_PLAYER_REPORT_BY_TIME_SUCCESS,
        payload: getPlayerReportByTimeResponse
    };
};

export const getPlayerReportByTimeError = (getPlayerReportByTimeResponse) => {
    return {
        type: GET_PLAYER_REPORT_BY_TIME_ERROR,
        payload: getPlayerReportByTimeResponse
    };
};

